import DecorativeEllipse from "@/components/DecorativeEllipse";

const bonuses = [
  {
    image:
      "https://static.readdy.ai/image/8febaa8ce715f731e0171f2e46fc1831/b3837ba11fa5a65be98ec74ea108cba2.webp",
    title: "De Mente Pobre a Mente Millonaria",
    desc: "Descubrí qué creencias te están frenando y cómo cambiarlas. Ejercicios concretos para empezar a tomar decisiones desde otro nivel.",
  },
  {
    image:
      "https://static.readdy.ai/image/8febaa8ce715f731e0171f2e46fc1831/bf88dfe605e10a43d8d41b37adfb412b.webp",
    title: "Los Hábitos del 1%",
    desc: "No es talento, es consistencia. Los hábitos diarios que marcan la diferencia entre la mujer que avanza y la que sigue en el mismo lugar.",
  },
  {
    image:
      "https://static.readdy.ai/image/8febaa8ce715f731e0171f2e46fc1831/21cb88257d667ce9591051654d8656d7.webp",
    title: "Emprende Sin Quebrarte",
    desc: "Caerse no es el problema, es no saber cómo levantarse. Una guía directa para construir sin perder la cabeza en el intento.",
  },
  {
    image:
      "https://static.readdy.ai/image/8febaa8ce715f731e0171f2e46fc1831/76e24a63fb3a6659cc0e78106908dbbf.webp",
    title: "De Empleada a Emprendedora Exitosa",
    desc: "Tu mayor activo no es tu puesto, sos vos. Aprendé a soltar la dependencia laboral y a construir algo propio con lo que ya tenés.",
  },
  {
    image:
      "https://static.readdy.ai/image/8febaa8ce715f731e0171f2e46fc1831/ba7d8b4b480ff0b29a3e13f70ed60fea.webp",
    title: "Productividad Imparable",
    desc: "El tiempo no se estira, se gestiona. Aprendé a organizar cada día para que tus metas avancen aunque tengas poco tiempo libre.",
  },
];

export default function BonusSection() {
  return (
    <section className="relative" style={{ backgroundColor: "#0D0D0D" }}>
      {/* Aurora animated background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-1/2 -left-1/2 w-[200%] h-[200%] animate-aurora opacity-30"
          style={{
            background: "radial-gradient(ellipse at 30% 20%, rgba(201,168,76,0.12) 0%, transparent 50%), radial-gradient(ellipse at 70% 80%, rgba(229,201,126,0.08) 0%, transparent 50%)"
          }}
        />
        <DecorativeEllipse
          className="-top-32 -left-32"
          size={400}
          opacity={0.07}
          blur={120}
        />
        <DecorativeEllipse
          className="-bottom-40 -right-40"
          size={450}
          opacity={0.05}
          blur={140}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-gold/[0.02] via-transparent to-gold/[0.03]" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 md:px-8 py-16 md:py-24">
        {/* Header */}
        <div className="text-center mb-14 md:mb-20">
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl text-cream mb-5 leading-tight">
            <span className="animate-shimmer bg-gradient-to-r from-cream via-gold to-cream bg-clip-text text-transparent" style={{ backgroundSize: "200% auto" }}>
              Bonus Exclusivo
            </span>
            <br />
            <span className="text-gold">y Oferta Especial</span>
          </h2>
          <p className="font-sans text-sm md:text-base text-cream/50 max-w-xl mx-auto">
            Para que tu experiencia sea aún más enriquecedora, agregamos 5 ebooks exclusivos disponibles solo en esta edición. Aprovechá ahora y empezá tu transformación sin esperar.
          </p>
        </div>

        {/* Sticky cards — NO overflow hidden here */}
        <div className="pb-32 md:pb-40">
          {bonuses.map((bonus, index) => {
            const topOffset = 80 + index * 60;
            const zIndex = 10 + index;

            return (
              <div
                key={index}
                className="md:sticky flex flex-col md:flex-row rounded-xl border border-gold/30 group hover:border-gold/50 transition-all duration-500 shadow-lg shadow-black/40"
                style={{
                  backgroundColor: "#1C1C1C",
                  top: `${topOffset}px`,
                  zIndex,
                  marginBottom: "16px",
                }}
              >
                {/* Image side */}
                <div className="relative w-full md:w-[200px] shrink-0 aspect-[2/3] overflow-hidden bg-[#111]">
                  <img
                    src={bonus.image}
                    alt={bonus.title}
                    className="w-full h-full object-cover object-top rounded-t-xl md:rounded-l-xl md:rounded-tr-none"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-[#1C1C1C]/80 hidden md:block" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#1C1C1C]/80 via-transparent to-transparent md:hidden" />
                </div>

                {/* Text side */}
                <div className="relative flex-1 flex flex-col justify-center p-5 md:p-6">
                  <div className="w-12 h-px bg-gold/40 mb-4" />

                  <h3 className="font-serif text-lg md:text-xl text-cream mb-2 group-hover:text-gold transition-colors duration-300">
                    {bonus.title}
                  </h3>

                  <p className="font-sans text-sm text-cream/60 leading-relaxed">
                    {bonus.desc}
                  </p>

                  <div className="w-12 h-px bg-gold/40 mt-4" />
                </div>
              </div>
            );
          })}
        </div>

        {/* Todos los ebooks juntos */}
        <div className="mb-12 md:mb-16 rounded-xl border border-gold/20 overflow-hidden bg-[#141414] p-4 md:p-6 animate-float">
          <img
            src="https://storage.readdy-site.link/project_files/47bfa220-4dc0-474b-be5e-43bab3838ebf/5bee5b1a-0ad3-4ce4-95b9-1c62c72f859a_AL-_-Todos-los-Ebooks.webp?v=d6e571ff18b38f12327e94e0ce89520d"
            alt="Todos los ebooks bonus"
            className="w-full h-auto rounded-lg object-cover"
            loading="lazy"
          />
          <p className="text-center font-sans text-sm text-cream/40 mt-4">
            5 ebooks exclusivos incluidos en esta edición
          </p>
        </div>

        {/* Special offer block */}
        <div className="mt-12 md:mt-16 rounded-lg p-8 md:p-12 text-center border border-gold/30 relative overflow-hidden animate-pulse-glow">
          <div className="absolute inset-0 bg-gradient-to-br from-gold-muted/20 via-gold-muted/10 to-transparent pointer-events-none" />
          <div className="absolute inset-0 bg-gold-radial pointer-events-none" />

          <div className="relative z-10">
            <h3 className="font-serif text-2xl md:text-3xl lg:text-4xl text-cream mb-4">
              Oferta Especial
            </h3>
            <div className="w-16 h-px bg-gold/40 mx-auto mb-5" />
            <p className="font-sans text-sm md:text-base text-cream/70 max-w-md mx-auto mb-2">
              Inscribite ahora y accedé a todos los bonus exclusivos.
            </p>
            <p className="font-sans text-sm md:text-base text-cream/50 max-w-md mx-auto mb-8">
              Después de esta fecha, el precio vuelve a su valor normal.
            </p>

            <a
              href="#pricing"
              className="inline-flex items-center justify-center gap-3 px-10 py-4 md:px-12 md:py-5 rounded-md font-sans font-semibold text-base md:text-lg text-white transition-all duration-300 hover:scale-[1.02] hover:brightness-110"
              style={{ backgroundColor: "#2E7D32" }}
            >
              <span>Quiero acceso ahora</span>
              <i className="ri-arrow-right-line text-lg" />
            </a>

            <p className="mt-4 font-sans text-xs text-cream/40">
              (Oferta sujeta a disponibilidad)
            </p>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="relative z-10 h-px bg-gold-gradient" />
    </section>
  );
}